export default __webpack_public_path__ + "static/media/offer_en.538058de.svg";